import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/program'

export const programService = {
    search,
    getItem,
    syncFirebase,
    saveItem,
    updateItem,
    deleteItem,
    translate,
};


function search(offset, max, dataFilter) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', dataFilter)
}

function syncFirebase() {
    return utilHelper.doRequest(`${relativeUrl}/syncFirebase`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}